import { render, staticRenderFns } from "./DataPermTypeSelect.vue?vue&type=template&id=88aea9d4&scoped=true&"
import script from "./DataPermTypeSelect.vue?vue&type=script&lang=js&"
export * from "./DataPermTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./DataPermTypeSelect.vue?vue&type=style&index=0&id=88aea9d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aea9d4",
  null
  
)

export default component.exports